import { FC } from 'react';
import ExplainabilityPopup from './ExplainabilityPopup/ExplainabilityPopup';
import { RISK_RULES } from '@silverfort-nodelibs/common/utils/insight';
import ShadowAdminExplainabilityPopup from './ShadowAdminExplainabilityPopup/ShadowAdminExplainabilityPopup';
import { PopupProps } from './ExplainabilityProps';

interface ExplainabilitySettings {
    popupTitle: string;
    popupComponent: FC<PopupProps>;
}

type ExplainabilityMap = Record<string, ExplainabilitySettings>;

const DEFAULT_EXPLAINABILITY_SETTINGS: ExplainabilitySettings = {
    popupTitle: 'Exposure Description',
    popupComponent: ExplainabilityPopup
};

const EXPLAINABILITY_SETTINGS_MAP: ExplainabilityMap = {
    [RISK_RULES.SHADOW_ADMIN]: {
        popupTitle: 'Why is this account a shadow admin?',
        popupComponent: ShadowAdminExplainabilityPopup
    },
    [RISK_RULES.MIXED_SESSION_HOST]: {
        ...DEFAULT_EXPLAINABILITY_SETTINGS,
        popupTitle: 'Who is compromised by this host?'
    }
};

export { EXPLAINABILITY_SETTINGS_MAP, DEFAULT_EXPLAINABILITY_SETTINGS };
export type { ExplainabilitySettings, ExplainabilityMap };
